import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { Alert, AlertTitle } from '@mui/material';
import {
    FormWrapper,
    FormCard,
    FormHeader,
    StyledForm,
    Label,
    Input,
    Textarea,
    SubmitButton,
    AlertWrapper
} from './styles/ContactFormStyles';

const ContactForm = () => {
    const [alertActive, setAlertActive] = useState(false);
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();
        emailjs.sendForm(process.env.REACT_APP_YOUR_SERVICE_ID, process.env.REACT_APP_YOUR_TEMPLATE_ID, form.current, process.env.REACT_APP_YOUR_PUBLIC_KEY)
            .then((result) => {
                e.target.reset();
                setAlertActive(true);
                setTimeout(() => setAlertActive(false), 5000);
                console.log(result);
            }, (error) => {
                console.log(error.text);
            });
    };

    return (
        <FormWrapper>
            <FormCard>
                {alertActive && (
                    <AlertWrapper>
                        <Alert severity="success">
                            <AlertTitle>Success</AlertTitle>
                            Email has been sent! <strong>I'll be in touch!</strong>
                        </Alert>
                    </AlertWrapper>
                )}

                <FormHeader>
                    <h1>Contact Me</h1>
                </FormHeader>

                <StyledForm ref={form} onSubmit={sendEmail}>
                    <div>
                        <Label htmlFor="user_name">Name</Label>
                        <Input id="user_name" required type="text" name="user_name" placeholder="Your name" />
                    </div>

                    <div>
                        <Label htmlFor="user_email">Email</Label>
                        <Input id="user_email" required type="email" name="user_email" placeholder="you@example.com" />
                    </div>

                    <div style={{ gridColumn: '1 / -1' }}>
                        <Label htmlFor="message">Message</Label>
                        <Textarea id="message" required name="message" placeholder="Write your message here..." />
                    </div>

                    <SubmitButton type="submit" value="Send Message" />
                </StyledForm>
            </FormCard>
        </FormWrapper>
    );
};

export default ContactForm;